import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//actions
import { postUpdated, updateFilterSelected } from '../actions';

class PracticeField extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.state = {
      query: null
    }
  }

  onChange = e => {
    let selected = this.selectRef.current.value;
    //update filters in redux
    this.props.updateFilterSelected('practice', selected);
    this.props.postUpdated('asc', selected, this.props.data, 'practice');
  };

  componentDidUpdate(prevProps, prevState) {
    // to recieve query vars
    //console.log(prevState.query);
    //console.log(this.props)
    if (this.props.query && this.props.query.practice && prevState.query === null)  {
      // decode and replace &amp; because the data is poor
      //let decodedQuery = decodeURIComponent(this.props.query.practice).replace('&amp;', '&');
      //this.setState({query: decodedQuery});
      //this.selectRef.current.value = decodedQuery;
      this.props.updateFilterSelected('practice', this.props.query.practice, true);
      this.props.postUpdated('asc', this.props.query.practice, this.props.data, 'practice');
    }
    
    if (this.props.filters.clear_filter.active) {
     this.clearField();
    }
   }

  clearField() {
    this.selectRef.current.value = '';
  }

  render() {
    return (
      <select className="form-control" ref={this.selectRef} onChange={this.onChange}>
        <option value="">Practice</option>
        <option value="appellate-litigation">Appellate Litigation</option>
        <option value="copyright">Copyright</option>
        <option value="counseling-opinions">
          Counseling, Opinions + Licensing
        </option>
        <option value="counterfeit-goods-seizure">Counterfeit Goods Seizure</option>
        <option value="design-patents">Design Patents</option>
        <option value="jury-trials">Jury Trials</option>
        <option value="litigation">Litigation</option>
        <option value="patent-interferences">Patent Interferences</option>
        <option value="patent-post-issuance-proceedings">Patent Post-Issuance Proceedings</option>
        <option value="patent-prosecution">Patent Prosecution</option>
        <option value="section-337itc-litigation">Section 337/ITC Litigation</option>
        <option value="trade-dress">Trade Dress</option>
        <option value="trade-secrets">Trade Secrets</option>
        <option value="trademarks">Trademarks</option>
      </select>
    );
  }
}

PracticeField.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = dispatch => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value, query) => dispatch(updateFilterSelected(filtername, value, query))
  };
};

const mapStateToProps = state => {
  return {
    type: state.postData.type,
    filteredData: state.postData.filteredData,
    data: state.postData.data,
    filters: state.filters
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PracticeField);
